var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.741 7.85714C16.741 10.5397 14.5524 12.7143 11.8526 12.7143C9.15281 12.7143 6.96418 10.5397 6.96418 7.85714C6.96418 5.17462 9.15281 3 11.8526 3C14.5524 3 16.741 5.17462 16.741 7.85714ZM15.1116 7.85714C15.1116 9.64549 13.6525 11.0952 11.8526 11.0952C10.0527 11.0952 8.59366 9.64549 8.59366 7.85714C8.59366 6.06879 10.0527 4.61905 11.8526 4.61905C13.6525 4.61905 15.1116 6.06879 15.1116 7.85714Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65826 17.967C5.92562 17.385 6.41674 16.6949 7.34005 16.1432C8.26828 15.5885 9.68562 15.1429 11.8527 15.1429C12.3026 15.1429 12.6674 14.7804 12.6674 14.3333C12.6674 13.8862 12.3026 13.5238 11.8527 13.5238C9.4613 13.5238 7.73711 14.0167 6.50029 14.7557C5.25854 15.4977 4.56107 16.4563 4.17592 17.2947C3.85125 18.0014 3.99902 18.7216 4.43037 19.2347C4.84154 19.7237 5.48085 20 6.14947 20H11.8526C12.3026 20 12.6673 19.6376 12.6673 19.1905C12.6673 18.7434 12.3026 18.381 11.8526 18.381H6.14947C5.91814 18.381 5.75441 18.2841 5.68096 18.1967C5.64675 18.156 5.63486 18.1222 5.63124 18.0981C5.62807 18.077 5.62669 18.0357 5.65826 17.967Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.741 13.5238C17.191 13.5238 17.5558 13.8862 17.5558 14.3333V15.9523L19.1853 15.9524C19.6352 15.9524 20 16.3148 20 16.7619C20 17.209 19.6352 17.5714 19.1852 17.5714L17.5558 17.5714V19.1905C17.5558 19.6376 17.191 20 16.741 20C16.2911 20 15.9263 19.6376 15.9263 19.1905V17.5713L14.2968 17.5713C13.8468 17.5713 13.4821 17.2088 13.4821 16.7617C13.4821 16.3147 13.8469 15.9522 14.2969 15.9522L15.9263 15.9523V14.3333C15.9263 13.8862 16.2911 13.5238 16.741 13.5238Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOwner);
export default __webpack_public_path__ + "static/media/add-owner.a54601dd3c02eed60b05834ad142145a.svg";
export { ForwardRef as ReactComponent };